import React from 'react';
import BallIcon from '../components/Icons/Ball.icon';
import ThumbsUpIcon from '../components/Icons/ThumbsUp.icon';
import PhoneIcon from '../components/Icons/Phone.icon';
import BriefcaseIcon from '../components/Icons/Briefcase.icon';

export const NOTIFICATION_CONNECT_TIMEOUT = 2000;

export enum NotificationTypes {
  GENERAL_TYPE = 'GENERAL_TYPE',
  META_TYPE = 'META_TYPE',
  TRIGGER_TYPE = 'TRIGGER_TYPE',
  NOTIFICATION_TYPE = 'NOTIFICATION_TYPE',

  // Person
  PERSON_RECORD_FEEDBACK_TYPE = 'PERSON_RECORD_FEEDBACK_TYPE',
  PERSON_RECORD_RE_CONTACT_TYPE = 'PERSON_RECORD_RE_CONTACT_TYPE',
  UPCOMING_INTERVIEW_TYPE = 'UPCOMING_INTERVIEW_TYPE',
}

export const NOTIFICATION_ICON: { [key: string]: React.ReactNode } = {
  [NotificationTypes.GENERAL_TYPE]: <BallIcon />,
  [NotificationTypes.PERSON_RECORD_FEEDBACK_TYPE]: <ThumbsUpIcon />,
  [NotificationTypes.PERSON_RECORD_RE_CONTACT_TYPE]: <PhoneIcon />,
  [NotificationTypes.UPCOMING_INTERVIEW_TYPE]: <BriefcaseIcon />,
};

export const NOTIFICATION_ICON_COLOR: { [key: string]: string } = {
  [NotificationTypes.GENERAL_TYPE]: 'LABEL',
  [NotificationTypes.PERSON_RECORD_FEEDBACK_TYPE]: 'NOTIFICATION_FEEDBACK',
  [NotificationTypes.PERSON_RECORD_RE_CONTACT_TYPE]: 'NOTIFICATION_RE_CONTACT',
  [NotificationTypes.UPCOMING_INTERVIEW_TYPE]:
    'NOTIFICATION_UPCOMING_INTERVIEW',
};
